
import Vue from 'vue';
import FilterChipTemplate from './FilterChipTemplate.vue';
import DeviceService from '@/services/DeviceService';
import PropertyService from '@/services/PropertyService';
import ConnectorService from '@/services/ConnectorService';
import { autoComplete } from '@/utils/Util';

export default Vue.extend({
  name: 'EntityComboFilter',
  components: { FilterChipTemplate },
  props: ['value', 'label', 'attributes', 'mandatory', 'always', 'small', 'entityType'],
  data: (_this: any): any => ({
    rules: [(v: any) => !!v || _this.requiredError],
    localSelection: _this.value[_this.attributes['value']] ?? null,
    localFilters: _this.value as any,
    menu: false,
    loading: false,
    entities: [],
  }),
  created() {
    this.loadEntities();
  },
  methods: {
    autoComplete,

    getEntityDisplayText(item: any): string {
      if (typeof item === 'string') return item;
      if (this.entityType === 'device') return item.aksId || item.uuid;
      return item.name || item.uuid;
    },

    loadEntities() {
      const tenant = this.$root.$store.state.session.selectedTenant.uuid;
      this.loading = true;
      this.entities = [];

      let promise: Promise<any[]> | null = null;
      if (this.entityType === 'device') {
        promise = DeviceService.getAllCollectionPages(tenant);
      } else if (this.entityType === 'property') {
        promise = PropertyService.getAllCollectionPages(tenant);
      } else if (this.entityType === 'connector') {
        promise = ConnectorService.getAllCollectionPages(tenant);
      }

      if (promise) {
        promise
          .then((items: any[]) => {
            this.entities = items;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    },

    onSave() {
      const val = this.localSelection;
      this.localFilters[this.attributes['value']] =
        typeof val === 'object' && val !== null ? val.uuid : val;
      this.$emit('input', { ...this.localFilters });
      this.menu = false;
    },

    onReset() {
      this.$delete(this.localFilters, this.attributes['value']);
      this.$emit('input', { ...this.localFilters });
      this.menu = false;
    },

    onChipRemove() {
      this.$delete(this.localFilters, this.attributes['value']);
      this.$emit('input', { ...this.localFilters });
      this.$emit('delete');
    },
  },
  watch: {
    value() {
      this.localFilters = { ...this.value };
      this.localSelection = this.localFilters[this.attributes['value']] ?? null;
    },
    menu() {
      if (!this.menu) {
        this.localSelection = this.localFilters[this.attributes['value']] ?? null;
      }
    },
    currentTenant() {
      this.entities = [];
      this.loadEntities();
    },
  },
  computed: {
    filterRepr(): any {
      const raw = this.localFilters[this.attributes['value']];
      if (!raw) return '';
      if (typeof raw === 'object') return raw.uuid || '';
      const found = this.entities.find((e: any) => e.uuid === raw);
      return found ? this.getEntityDisplayText(found) : raw;
    },
    isValid(): any {
      return this.mandatory
        ? this.rules.reduce(
            (acc: boolean, rule: any) => (acc ? rule(this.localSelection) === true : acc),
            true
          )
        : true;
    },
    requiredError(): any {
      return this.$t('required');
    },
    itemTextField(): string {
      if (this.entityType === 'device') return 'aksId';
      return 'name';
    },
    currentTenant(): any {
      return this.$root.$store.state.session.selectedTenant.uuid;
    },
  },
});
